export const SET_PLATFORM_NOTIFICATIONS = "SET_PLATFORM_NOTIFICATIONS";
export const LOAD_PLATFORM_NOTIFICATIONS = "LOAD_PLATFORM_NOTIFICATIONS";
export const LOAD_NOTIFICATIONS = "LOAD_NOTIFICATIONS";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SET_NOTIFICATIONS_ERROR = "SET_NOTIFICATIONS_ERROR";
export const LOAD_MY_NOTIFICATIONS = "LOAD_MY_NOTIFICATIONS";
export const SET_MY_NOTIFICATIONS = "SET_MY_NOTIFICATIONS";
export const SET_MY_NOTIFICATIONS_ERROR = "SET_MY_NOTIFICATIONS_ERROR";